/**
 * Disable all unavailable Events
 *
 * @param {*} selector
 */

export const setEventDisabled = (selector) => {
  const selection = document.querySelectorAll(selector);
  if (selection.length > 0) {
    selection.forEach((element) => {
      element.disabled = true;
    });
  }
};

/**
 * Reset values of all the inputs
 *
 * @param {*} section
 */

export const resetAllValues = (section) => {
  if (section.querySelector(".quantity")) {
    section.querySelector(".quantity .qty-input").value = "0";
    section.querySelector(".quantity .btn-minus").disabled = true;
    section.querySelector(".quantity .btn-plus").disabled = false;
  }
};

/**
 * Open Multistep Checkout Section
 *
 * @param string selector
 * @param bool scroll
 */

export const openMultistepSection = (selector, scroll = true) => {
  const section = document.getElementById(selector);
  let anchor = null;
  if (section) {
    let sectionHeight = "auto",
      anchor = selector;

    if (selector === "event-calendar-date-section") {
      sectionHeight = "640px";
    } else if (selector === "final-checkout-section") {
      anchor = "event-calendar-ticket-price-section";
    }
    Object.assign(section.style, {
      height: sectionHeight,
      marginBottom: "82px",
    });
    if (selector != "final-checkout-section" && scroll) {
      window.scrollTo({
        top: section.getBoundingClientRect().top + window.scrollY - 100,
        behavior: "smooth",
      });
    }
  }
};

/**
 * Close Multistep Checkout Section and reset data
 */

export const closeMultistepSections = () => {
  document.querySelectorAll(".multistep-section").forEach(function (section) {
    Object.assign(section.style, {
      height: "0",
      marginBottom: "0px",
    });
    resetAllValues(section);
  });
  Object.assign(document.querySelector("#final-checkout-section"), {
    selectedSlot: "",
    selectedServices: "",
    selectedQuantity: "",
  });
};
